import React from 'react'
import ReactDom from 'react-dom'
import { Router, Route, hashHistory, IndexRedirect } from 'react-router'
import { Provider } from 'react-redux'
import Promise from 'promise-polyfill'
import Loadable from "react-loadable"
import http from '/api/index'
import { handleLocation } from '/api/tools'
if (!window.Promise) {
  window.Promise = Promise
}
import store from '/redux/store'
import '/assets/less/main.less'
import Loading from '/components/loading.jsx'
const Load = loader => Loadable({
   loader,
   loading: Loading
})
// 判断是否是ios 还是 android
let u = navigator.userAgent;
window.isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
window.isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
window.platform = (u.indexOf('Feishu') >= 0 || u.indexOf('Lark') >= 0) ? 'feishu' : 'wxwork'; //钉钉 or 企业微信
//飞书appId
// window.feishu_appid = 'cli_a74bf532c16b901c';//测试
window.feishu_appid = 'cli_a74028a26c4a500c';//生产
// window.feishu_appid = 'cli_a7a33fc3d3e2900b';//UAT
// 用户认证，入口带有微信转发的参数code，可以根据code获得用户的openId
var params = handleLocation()
console.log('params -> ',  params)
if(params.code){
	http.fetchAuth({code: params.code})
}else if(params.psncode){
	http.fetchAuth(params)
}

const Page = Load(() => import('./app.jsx'))
const Home = Load(() => import('/page/home.jsx'))
const Processform = Load(() => import('/page/hometabs/processform.jsx'))
const Editform = Load(() => import('/page/hometabs/editform.jsx'))
const ErrorPage = Load(() => import('/page/error.jsx'))
const LoginPage = Load(() => import('/page/login.jsx'))

const routeConfig = (
	<Route path = {'/'} component = {Page}>
		<IndexRedirect to="/home"/>
		<Route path = {'home'} component = {Home} />
		<Route path = {'processform'} component = {Processform} />
		<Route path = {'editform'} component = {Editform} />
		<Route path = {'error'} component = {ErrorPage} />
		<Route path = {'login'} component = {LoginPage} />
	</Route>
)




ReactDom.render(
	<Provider store = { store }>
		<Router history = { hashHistory }>
        	{routeConfig}
		</Router>
	</Provider>
	,
    document.getElementById('root')
)



// WEBPACK FOOTER //
// ./src/main.js